import type React from 'react';
import type { JSX } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomSportsEsports = ({
    color,
    opacity = '1',
    fillOpacity = '1',
    size = 24, // This icon is typically 24x24, larger than other sports icons
    props,
}: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} {...props} viewBox={`0 0 ${size} ${size}`}>
        <path
            d="M4.55 19C3.7 19 3.04167 18.7042 2.575 18.1125C2.10833 17.5208 1.93333 16.8 2.05 15.95L3.1 8.45C3.25 7.45 3.69583 6.625 4.4375 5.975C5.17917 5.325 6.05 5 7.05 5H16.95C17.95 5 18.8208 5.325 19.5625 5.975C20.3042 6.625 20.75 7.45 20.9 8.45L21.95 15.95C22.0667 16.8 21.8917 17.5208 21.425 18.1125C20.9583 18.7042 20.3 19 19.45 19C19.1 19 18.775 18.9375 18.475 18.8125C18.175 18.6875 17.9 18.5 17.65 18.25L15.4 16H8.6L6.35 18.25C6.1 18.5 5.825 18.6875 5.525 18.8125C5.225 18.9375 4.9 19 4.55 19ZM17 13C17.2833 13 17.5208 12.9042 17.7125 12.7125C17.9042 12.5208 18 12.2833 18 12C18 11.7167 17.9042 11.4792 17.7125 11.2875C17.5208 11.0958 17.2833 11 17 11C16.7167 11 16.4792 11.0958 16.2875 11.2875C16.0958 11.4792 16 11.7167 16 12C16 12.2833 16.0958 12.5208 16.2875 12.7125C16.4792 12.9042 16.7167 13 17 13ZM15 10C15.2833 10 15.5208 9.90417 15.7125 9.7125C15.9042 9.52083 16 9.28333 16 9C16 8.71667 15.9042 8.47917 15.7125 8.2875C15.5208 8.09583 15.2833 8 15 8C14.7167 8 14.4792 8.09583 14.2875 8.2875C14.0958 8.47917 14 8.71667 14 9C14 9.28333 14.0958 9.52083 14.2875 9.7125C14.4792 9.90417 14.7167 10 15 10ZM7.75 13H9.25V11.25H11V9.75H9.25V8H7.75V9.75H6V11.25H7.75V13Z"
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
